export default "__VITE_ASSET__DmIh1KnT__"